export const headerWrapStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
};
export const searchWrapStyles = {
    display: 'flex',
    alignItems: 'flex-start'
};
